import { render, staticRenderFns } from "./add-quality-guarantee.vue?vue&type=template&id=4bfab74b&scoped=true"
import script from "./add-quality-guarantee.vue?vue&type=script&lang=js"
export * from "./add-quality-guarantee.vue?vue&type=script&lang=js"
import style0 from "./add-quality-guarantee.vue?vue&type=style&index=0&id=4bfab74b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfab74b",
  null
  
)

export default component.exports